var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwissMade = function SvgSwissMade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Swiss_Made_svg__Ebene_2",
    viewBox: "0 0 92.59 92.59"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Swiss_Made_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:1.95px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Swiss_Made_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.06.97h34.48v90.64H29.06z",
    className: "Swiss_Made_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.97 63.53V29.05h90.64v34.48z",
    className: "Swiss_Made_svg__cls-1"
  }))));
};
export default SvgSwissMade;